import { ref } from 'vue';
import { apiRecipientGroupList } from '@/request/api';

export default ({ callback }) => {
    const groupList = ref([]);
    const currentGroupId = ref('');

    // 获取所有收藏夹
    async function getGroupList() {
        const { data } = await apiRecipientGroupList();
        groupList.value = data || [];
        if (groupList.value.length && !currentGroupId.value) {
            currentGroupId.value = groupList.value[0].id;
        }
        currentGroupId.value && callback();
    }

    getGroupList();

    return { groupList, currentGroupId, getGroupList }
}